module.exports = __webpack_public_path__ + "img/Post_a_Job_active.af616c66.svg";